import React, { useEffect, useState } from 'react'
import prodata from '../ApiData/ProfileData.json'
import ProjectsProfile from '../ProjectsProfile/ProjectsProfile'
import './Api.css'
import code from '../img/commit.png'
// import soft from '../../Gif/Software engineer.gif'
// import soft from '../../Gif/Design thinking.gif'
import soft from '../../Gif/BlackCommit.gif'
import aos from "aos";
import "aos/dist/aos.css";
// FF2375
const Api = () => {
    document.title="💻 Working | Rian Islam"

    const [profile,setProfile] = useState([])
    const lastUpdate = prodata.slice(0,5)
    useEffect(() =>{
        setProfile(lastUpdate);
        console.log(lastUpdate);
    },[])

    
  useEffect(() => {
    aos.init({ duration: 2000 });
  }, []);

    return (
        <div className="container">
            <div className="row repo-space-end repo-space ">
            <div data-aos="fade-right" className="col-md-4 col-lg-4 col-sm-12 my-5 order-sm-2 order-lg-1">
                {/* <img src={code} className="img-fluid" alt=""/> */}
                <img src={soft} className="img-fluid" alt=""/>
                {/* <img src="https://user-images.githubusercontent.com/67714964/117015711-cd94d880-ad13-11eb-85b7-6d2371462177.gif" className="img-fluid" alt=""/> */}
                <h3 className="text-center text-success">Latest commit</h3>
            </div>
            <div className="col-md-2"></div>
            <div data-aos="fade-left" className="col-md-6 col-lg-6 col-sm-12 order-sm-1 order-lg-2">
            <h1 className="text-success">Latest Repos</h1>
            {
                profile.map((pp) =>( <ProjectsProfile pro={pp}/>) )
            }
            </div>
            
                
            </div>
        </div>
    )
}

export default Api
